import type { SunoPrompt, SunoPromptBaseSnapshot } from '../../../api/suno'

export type SelectedBasePrompt = SunoPromptBaseSnapshot & {
  source: 'library' | 'history'
}

export const promptToBaseSnapshot = (prompt: SunoPrompt): SunoPromptBaseSnapshot => ({
  id: prompt.id,
  title: prompt.title,
  description: prompt.description,
  style_prompt: prompt.style_prompt,
  exclude_prompt: prompt.exclude_prompt
})

export const selectedPromptToSnapshot = (prompt: SelectedBasePrompt): SunoPromptBaseSnapshot => ({
  id: prompt.id,
  title: prompt.title,
  description: prompt.description,
  style_prompt: prompt.style_prompt,
  exclude_prompt: prompt.exclude_prompt
})
